import script from "./EditNoteForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditNoteForm.vue?vue&type=script&setup=true&lang=ts"

import "./EditNoteForm.vue?vue&type=style&index=0&id=bb5fff24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb5fff24"]])

export default __exports__